export const siteTitle = '逃脫吧 - Escapebar';
export const siteUrl = 'https://escape.bar';
export const userPageMetaContent = '逃脫成功！快來看看我精彩的密室逃脫全記錄吧！';
export const userPageNotPublicMetaContent = '此使用者還在逃脫中，目前找不到密室逃脫紀錄！';
export const DEFAULT_AVATAR_SRC = '/img/logo-avatar.svg';
export const DEFAULT_FULL_LOGO_SRC = '/img/logo-square-full.svg';
export const GAME_CARD_IMAGE_PLACEHOLDER_SRC = '/img/game-card-placeholder.jpg'
export const SITE_SOCIAL_BANNER_SRC = '/img/sns-sharing-2024.jpg'